import * as constants from './constants';

export function setUserData(data) {
  return { type: constants.SET_USER_DATA, payload: data };
}

export function setAuth(value) {
  return { type: constants.SET_AUTH_USER, payload: value };
}

export function setIsLoggedIn(value) {
  return { type: constants.IS_LOGGED_IN, payload: value };
}

export function setShowPhoneVerificationModal(value) {
  return { type: constants.SET_SHOW_PHONE_VERIFICATION_MODAL, payload: value };
}

export function setShowEmailVerificationModal(value) {
  return { type: constants.SET_SHOW_EMAIL_VERIFICATION_MODAL, payload: value };
}

export function setErrorLoginDAC(value: boolean) {
  return { type: constants.SET_ERROR_LOGIN_DAC, payload: value };
}

export function setLoadingLoginDAC(value: boolean) {
  return { type: constants.SET_LOADING_LOGIN_DAC, payload: value };
}

export function setLoading(value: boolean) {
  return { type: constants.SET_LOADING, payload: value };
}